<p-dataView *ngIf="dataView" #dv [value]="products" [paginator]="true" [rows]="9" filterBy="name" layout="grid">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
            <span class="p-input-icon-left p-mb-2 p-mb-md-0">
                <i class="pi pi-search"></i>
                <input type="search" pInputText placeholder="Search by Name" (input)="dv.filter($event.target.value)">
            </span>
            <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
        </div>
    </ng-template>
    <ng-template let-productLists pTemplate="list">
        <div class="p-grid">
            <div *ngFor="let product of productLists" class="p-col-12">
                <p-card class="product-item">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-text-center">
                            <img [src]="assestBaseUrl + 'images/' + product.img" [alt]="product.name"/>
                            <div class="p-mt-2"><strong>{{product.name}}</strong></div>
                        </div>
                        <div class="p-d-flex p-flex-column p-text-right">
                            <div>
                                <p-button label="Install" (click)="installBtn(product)" *ngIf="product.showInstall"></p-button>
                                <span class="pi pi-spin pi-spinner" *ngIf="product.showSpin"></span>
                                <p-button icon="pi pi-check" (click)="uninstallBtn(product)" *ngIf="product.showInstalled"></p-button>
                            </div>
                            <p-button class="p-mt-auto" label="Details" (click)="changeTableView(product)" *ngIf="product.showDetail"></p-button>
                        </div>
                    </div>
                    <div class="p-mt-2 leaddescName" (click)="showMoreInfo(product)">
                        {{(product.description.length>22) ? (product.description | slice:0:22) + '... More' : product.description}}
                    </div>
                </p-card>
            </div>
        </div>
    </ng-template>
    <ng-template let-productLists pTemplate="grid">
        <div class="p-grid">
            <div *ngFor="let product of productLists" class="p-col-12 p-md-4">
                <p-card class="product-item">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-text-center">
                            <img [src]="assestBaseUrl + 'images/' + product.img"  [alt]="product.name"/>
                            <div class="p-mt-2"><strong>{{product.name}}</strong></div>
                        </div>
                        <div>
                            <p-button label="Install" (click)="installBtn(product)" *ngIf="product.showInstall"></p-button>
                            <span class="pi pi-spin pi-spinner" *ngIf="product.showSpin"></span>
                            <p-button icon="pi pi-check" (click)="uninstallBtn(product)" *ngIf="product.showInstalled"></p-button>
                        </div>
                    </div>
                    <div class="p-d-flex p-jc-between">
                        <div class="p-mt-2 leaddescName" (click)="showMoreInfo(product)">
                            {{(product.description.length>22) ? (product.description | slice:0:22) + '... More' : product.description}}
                        </div>
                        <div>
                            <p-button label="Details" (click)="changeTableView(product)" *ngIf="product.showDetail"></p-button>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>
    </ng-template>
</p-dataView>
<ng-container *ngIf="!dataView">
    <ng-container *ngIf="isSMS">
        <p-table [value]="activeNumbers">
            <ng-template pTemplate="caption">
                <div class="table-header p-d-flex">
                    <p-button icon="pi pi-arrow-left" label="Back" (click)="backDataView()"></p-button>
                    <h5 class="p-ml-3 p-mt-1">SMS Setup</h5>
                </div>
                <div class="table-header p-d-flex p-jc-between">
                  <h5 class="p-ml-3 p-mt-1">Active Numbers</h5>
                  <p-button label="Buy a Number" (click)="buyNumber()"></p-button>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>Number</th>
                    <th>Status</th>
                    <th class="p-col-2">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr>
                  <td>
                      <div><span style="color: red;" class="pi pi-times p-mr-2" *ngIf="!data.isActive"></span>
                          ({{data.countryCode}}) {{data.nationalFormat}}</div>
                      <div>{{data.city}}, {{data.state}} {{data.country}}</div>
                  </td>
                    <td *ngIf="data.status == 'Pending Registration'">
                    <span class="pointer" (click)="openRegistration()">
                        {{data.status}}
                    </span>
                    </td>
                    <td *ngIf="data.status !== 'Pending Registration'">
                        {{data.status}}
                    </td>
                    <td class="action">
                      <span class="btnBars" (click)="openMessageLog(data)" pTooltip="Message Logs" tooltipPosition="top">
                          <i class="pi pi-comment"></i>
                      </span>
                      <span class="btnBars" (click)="confirmRelease(data)" pTooltip="Release Phone Number" tooltipPosition="top">
                          <i class="pi pi-ban"></i>
                      </span>
                  </td>
                </tr>
            </ng-template>
          </p-table>
    </ng-container>
    <app-whatsapp-setup *ngIf="isWhatsapp" (goBackView)="dataView = true"></app-whatsapp-setup>
</ng-container>

<p-dialog header="Information details" [(visible)]="displayMoreInfo" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <div class="card">
    <div class="p-field p-formgrid p-grid">
      {{fullInfo?.description}}
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayMoreInfo=false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton label="Save"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Buy a Number" [(visible)]="displayBuyNumber" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">

  <div [formGroup]="phoneNumberPurchaseForm" class="card">
    <div class="p-grid">
      <div class="p-col-12 p-md-6">
        <label>Country</label>
        <p-dropdown [options]="countries"   placeholder="Select country" [filter]="true"
        filterBy="displayLabel" inputId="country" optionLabel="displayLabel"  appendTo="body"
        dataKey="id"  formControlName="selectedCountry"></p-dropdown>
      </div>
    </div>
    <div class="p-grid">
        <div class="p-col-12 p-md-3">
            <label>Search Critiria</label>
            <p-dropdown [options]="critiria" placeholder="Select" optionLabel="name" appendTo="body"
            dataKey="id" formControlName="SearchCriteria"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-3 p-mt-5">
            <input type="text" formControlName="SearcByNumberOrPhrase"  pInputText placeholder="Search by digits or phrases..." >
        </div>
        <div class="p-col-12 p-md-3">
            <label>Match to</label>
            <p-dropdown [options]="matchTo" placeholder="Select" optionLabel="name" appendTo="body"
            dataKey="id"  formControlName="MatchTo"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-3 p-mt-5">
            <p-button type="submit" [disabled]="phoneNumberPurchaseForm?.invalid" (click)="searchNumber()" label="Search" ></p-button>
            <button type="button" (click)="clear()" pButton label="Clear" class="p-button-secondary p-ml-2"></button>
        </div>
        <div class="p-col-12">
            <p>Search by area code, prefix, or characters you want in your phone number.</p>
        </div>
    </div>
  </div>
  <p-table *ngIf="allNumbers?.length" [value]="allNumbers" responsiveLayout="scroll">
    <ng-template pTemplate="header">
        <tr>
            <th>Number</th>
            <th>Monthly fee</th>
            <th style="width: 3rem"></th>
        </tr>
    </ng-template>
    <!-- Here  we have to call the search api and get the data -->
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>
                <div>({{product?.friendlyName}})</div>
                <div>{{product?.locality}}, {{product?.region}} {{product?.isoCountry}}</div>
            </td>
            <td>{{product?.monthlyFees | number: "1.2-2" | currencySymbol}}</td>
            <td>
                <p-button label="Buy" (click)="buyPhoneNumber(product)"></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>
  <p-footer>
    <button type="button" pButton (click)="displayBuyNumber=false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton label="Save"></button>
  </p-footer>
</p-dialog>

<p-dialog #dt header="Messages Log" [(visible)]="displayMessageLog" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <p-table [value]="messages" responsiveLayout="scroll" [rows]="10" [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10,25,50]" [paginator]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [globalFilterFields]="['dateCreated','direction','from','to','status']">
    <ng-template pTemplate="caption">
        <div class="p-text-right">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Date</th>
            <th pSortableColumn="direction">Direction <p-sortIcon field="direction"></p-sortIcon></th>
            <th>From</th>
            <th>To</th>
            <th>Status</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>
                {{product.dateCreated | date:'medium'}}
            </td>
            <td>{{product.direction}}</td>
            <td>{{product.from}}</td>
            <td>{{product.to}}</td>
            <td>{{product.status}}</td>
        </tr>
    </ng-template>
</p-table>
  <p-footer>
    <button type="button" pButton (click)="displayMessageLog=false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton label="Save"></button>
  </p-footer>
</p-dialog>

<app-add-phone *ngIf="displayAddPhone" [display]="displayAddPhone" [isView]="isView"
(closeModal)="cancelAdd()" [selectedProduct]="selectedProduct"></app-add-phone>

<app-registration *ngIf="displayRegistration" [display]="displayRegistration"
                  (closeModal)="cancelRegistration()"></app-registration>
